import cn from "classnames";
import styles from "./Block.module.scss";

export const Block = ({name, title, desc, children}) => {
    return (
        <div className={cn(name, styles.zero)}>
            <div className={styles.content}>
                {title ? <div className={styles.title}>{title}</div> : ''}
                {desc ? <div className={styles.desc}>{desc}</div> : ''}
                {children}
            </div>
        </div>
    )
}